import { render, staticRenderFns } from "./DeviceTagIcon.vue?vue&type=template&id=91008b58&scoped=true&"
import script from "./DeviceTagIcon.vue?vue&type=script&lang=js&"
export * from "./DeviceTagIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91008b58",
  null
  
)

export default component.exports